import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import axios from "axios";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import logo from './assets/logo.svg';
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { API_URL } from "./config";
import Footer from "./components/Footer";


function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://Acilcocukdoktoru.com/">
        Acilcocukdoktoru.com
      </Link>{" "}
      {new Date().getFullYear()}
      {/* {'.'} */}
    </Typography>
  );
}

const theme = createTheme();
const Forgot = () => {
  const paperStyle = {
    padding: 30,
    height: "30vh",
    width: 360,
    margin: "0 auto",
  };
  const [email, setEmail] = useState();
  const onChangeEmail = (value) => {
   setEmail(value);
  };

  const handleCheckUser = async () => {
    try {
      console.log("buraya girdin mi1");
      const response = await axios.post(
        `${API_URL}/auth/request-password-reset`,
        null,
        { params: { email:email } }
      );
      console.log('Response:', response);

      const responseData = response.data;

      if (response.status === 200) {
        if (responseData.message === "Şifre sıfırlama isteği alındı") {
          console.log("Sıfırlama bağlantısı gönderildi.");
          alert("Sıfırlama bağlantısı gönderildi.");
        } else {
          console.log("Bilinmeyen bir hata oluştu:", responseData.message);
          alert("Bilinmeyen bir hata oluştu: " + responseData.message);
        }
      } else {
        console.log("Sunucu hatası:", response.statusText);
        alert("Sunucu hatası: " + response.statusText);
      }
    } catch (error) {
      console.error("Bir hata oluştu:", error);

      if (error.response) {
        console.error(
          "Sunucu tarafından gönderilen hata:",
          error.response.data.detail
        );
        alert(
          "Sunucu tarafından gönderilen hata: " + error.response.data.detail
        );
      }
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container
        component="main"
        maxWidth="xs"
        style={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
        }}
      >
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img width={"70%"} src={logo} />
          <br />
          <Typography component="h1" variant="h5" textAlign={"center"}>
            Acil Doktor Bulucu
            <br /> Şifre Sıfırlamak için lütfen sisteme kayıt olduğunuz eposta
            adresinizi giriniz
          </Typography>

          <Box noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="email"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={(event) => {
                onChangeEmail(event.target.value);
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              color="primary"
              onClick={handleCheckUser}
            >
              Sıfırla
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
      <Footer />
    </ThemeProvider>
  );
};

export default Forgot;
